import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import styled from 'styled-components';
import Fab from '@mui/material/Fab';
import { makeStyles } from '@mui/styles';
// import IconButton from '@material-ui/core/IconButton';

export var VideoContainer = styled.div.withConfig({
  displayName: "style__VideoContainer",
  componentId: "sc-wm3l8z-0"
})(["display:flex;padding:1rem;position:relative;width:100%;padding:0 !important;margin:10px 0 0 0 !important;display:block !important;iframe{width:100% !important;"]);
export var CloseBtn = styled(Fab).withConfig({
  displayName: "style__CloseBtn",
  componentId: "sc-wm3l8z-1"
})(["&&{right:10px;top:10px;position:absolute;}"]);
export var useClasses = makeStyles(function (theme) {
  return {
    video: _defineProperty({}, theme.breakpoints.down('xs'), {
      width: '250px',
      height: '175px'
    })
  };
});